export const DEFAULT_LANDING_PAGE = '/my-learning';
export const DEFAULT_MY_LEARNING_REDIRECT_PATH = '/my-learning/profile/select';
export const DEFAULT_ERROR_PATH = `${DEFAULT_MY_LEARNING_REDIRECT_PATH}?return_to=${encodeURIComponent(
  DEFAULT_LANDING_PAGE
)}`;
export type AppName = 'my-learning' | 'nme';

export interface RedirectParams {
  modality: string;
  redirect_to: string;
  subject: string;
  upgrade: boolean;
}

export class RedirectService {
  private params: RedirectParams;
  constructor(params: RedirectParams) {
    this.params = params;
  }
  /**
   * This function is responsible for the business logic around redirects. Currently there are 3 params,
   * that are provided along on the class constructor:
   * @upgrade {boolean} - Has priority over everything. If its present, it'll redirect to the upgrade page
   * @modality {string} - Interacts with subject. Sends to a my-learning page, that differs based on wether subject is present or not
   * @subject {string} - If only a subject is present, the user is sent to its corresponding subject page
   * @returns Returns the URL to be redirected
   */
  private getRedirectUrl(): string {
    if (this.params.upgrade) return `/memberships/upgrade/now`;
    if (this.params.modality) {
      if (this.params.modality !== 'ai-chat') return DEFAULT_LANDING_PAGE;
      return this.params.subject
        ? `/my-learning/subjects/${this.params.subject}#ai-chat`
        : `${DEFAULT_LANDING_PAGE}#ai-chat`;
    }
    if (this.params.subject)
      return `/my-learning/subjects/${this.params.subject}?accessType=1&action=1`;
    // Default
    return DEFAULT_LANDING_PAGE;
  }

  /**
   * Returns the URL that does a redirect in my-learning. My-learning has some internal logic for redirects
   * currently it accepts any redirection URL, and has a component that handles this thats present on the
   * profile selection page.
   */
  private getMyLearningRedirect(redirect_to: string): string {
    if (!redirect_to) return DEFAULT_MY_LEARNING_REDIRECT_PATH;
    return `${DEFAULT_MY_LEARNING_REDIRECT_PATH}?return_to=${encodeURIComponent(redirect_to)}`;
  }
  private getNmeRedirect(url: string): string {
    return url;
  }

  public getRedirect(): string {
    const url = this.getRedirectUrl();
    // If theres a redirect_to param just use it
    if (this.params.redirect_to) return String(this.params.redirect_to);
    // Upgrade goes to a NME url
    if (this.params.upgrade) return this.getNmeRedirect(url);
    if (this.params.subject || this.params.modality) return this.getMyLearningRedirect(url);
    // Default to my-learning
    return this.getMyLearningRedirect(DEFAULT_LANDING_PAGE);
  }
}
